import footerBar from '@/components/footer-bar';
export default {
  components: {
    footerBar
  },

  setup() {}

};